import { ChannelsService } from '@/service/ChannelsService'
import Model from './Model'
import { ChannelRoles } from './Users'

export enum ChannelVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export interface IChannel {
  _id?: string
  locationId: string
  groupId: string
  name: string
  description?: string
  icon?: any
  visibility: ChannelVisibility
  isAnnouncement?: boolean
  channelSlug?: string
  membersCount?: number
  userRole?: ChannelRoles
  managers?: string[]
}

export interface IChannelMember {
  contactId: string
  fullName: string
  slug: string
  role: ChannelRoles
  avatar: string
  _id: string
}

export default class Channel extends Model {
  // protected channelsData: any
  constructor(payload: IChannel) {
    super(payload, ChannelsService)
  }

  // set id(_id: string) {
  //     this._data._id = _id
  // }

  // get id(): string {
  //     return this._data._id
  // }

  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get groupId(): string {
    return this._data.groupId
  }

  set groupId(groupId: string) {
    this._data.groupId = groupId
  }

  get name(): string {
    return this._data.name
  }

  set name(name: string) {
    this._data.name = name
  }

  get description(): string {
    return this._data.description
  }

  set description(description: string) {
    this._data.description = description
  }

  get icon(): string {
    return this._data.icon
  }

  set icon(icon: string) {
    this._data.icon = icon
  }

  get visibility(): string {
    return this._data.visibility
  }

  set visibility(visibility: string) {
    this._data.visibility = visibility
  }

  get slug(): string {
    return this._data.slug
  }

  set slug(slug: string) {
    this._data.slug = slug
  }

  get membersCount(): number {
    return this._data.membersCount
  }

  set membersCount(membersCount: number) {
    this._data.membersCount = membersCount
  }

  get isAnnouncement(): boolean {
    return this._data.isAnnouncement
  }

  set isAnnouncement(isAnnouncement: boolean) {
    this._data.isAnnouncement = isAnnouncement
  }

  get userRole(): string {
    return this._data.userRole
  }

  set userRole(userRole: string) {
    this._data.userRole = userRole
  }

  get managers(): string[] {
    return this._data.managers
  }

  set managers(managers: string[]) {
    this._data.managers = managers
  }
}
